import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {Colors} from "@shared/styles/colors";

interface DrawerProps {
    $isOpen: boolean;
}

const DrawerContainer = styled.div<DrawerProps>`
    width: 218px;
    height: 100%;
    background-color: ${Colors.defaultContainerColor};
    display: flex;
    flex-direction: column;
    //padding: 20px;
    padding-right: 20px;
    padding-left: 20px;
    //padding-top: 20px;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    position: fixed; /* 작은 화면 기본값 */
    top: 0;
    left: ${(props) => (props.$isOpen ? "0" : "-300px")};
    transition: left 0.3s ease-in-out;
    z-index: 1000;

    @media (min-width: 1200px) {
        position: static; /* 큰 화면에서는 정적 배치 */
        box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
        left: 0; /* 항상 보이도록 설정 */
        height: 100vh;
        background-color: ${Colors.defaultContainerColor};
    }
`;

const DrawerMenu = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const MenuItem = styled(NavLink)`
    text-decoration: none;
    color: ${Colors.boldTextColor};
    font-size: 18px;
    font-family: Pretendard-Medium, emoji;
    padding: 10px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &.active {
        background-color: ${Colors.lightPurple};
        font-weight: bold;
    }

    &:hover {
        background-color: ${Colors.lightPurple};
    }
`;

const MenuItemWrapper = styled.div`
    display: flex;
    align-items: center;
`;
const MenuItemImage = styled.img`
    width: 28px;
    margin-right: 16px;
`;

const ContentContainer = styled.div`
    flex-grow: 1;
    //padding: 20px;
    background-color: ${Colors.defaultBackgroundColor};

    height: 100vh;
    overflow-y: auto;
    padding-left: 30px;
    padding-right: 30px;

    @media (max-width: 960px) {
        padding-left: 15px;
        padding-right: 15px;
    }

`;

const MenuButton = styled.button`
    position: absolute;
    left: 30px;
    border: none;
    cursor: pointer;
    z-index: 900;
    border-radius: 12px;
    padding: 12px;
    margin-top: 5px;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.defaultContainerColor};
    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.2); /* props로 받은 shadowAlpha 적용 */
    //background-color: transparent;

    img {
        width: 30px;
        height: 30px;
    }

    @media (min-width: 1200px) {
        display: none; /* 큰 화면에서는 숨기기 */
    }

    @media (max-width: 960px) {
        left: 15px
    }

`;

const MenuButtonItem = styled.button`
    text-decoration: none;
    color: ${Colors.boldTextColor};
    font-size: 18px;
    font-family: Pretendard-Medium, emoji;
    padding: 10px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    justify-content: space-between;

    &:hover {
        background-color: ${Colors.lightPurple};
    }
`;

const SubMenu = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-left: 44px;
`;

const SubMenuItem = styled(NavLink)`
    text-decoration: none;
    color: ${Colors.boldTextColor};
    font-size: 16px;
    padding: 8px;
    border-radius: 4px;

    &.active {
        background-color: ${Colors.lightPurple};
        font-weight: bold;
    }

    &:hover {
        background-color: ${Colors.lightPurple};
    }
`;

export const s = {
    DrawerContainer,
    DrawerMenu,
    MenuItem,
    MenuItemImage,
    ContentContainer,
    MenuButton,
    SubMenu,
    SubMenuItem,
    MenuButtonItem,
    MenuItemWrapper,
};
